import { render } from "./route-view.vue?vue&type=template&id=6717b23e"
const script = {}
script.render = render

export default script